export default {
  namespaced: true,
  state: {
    tabIndex: 0
  },
  getters: {
    contentTabIndex: (state) => state.tabIndex
  },
  mutations: {
    SET_TAB_INDEX(state, index) {
      state.tabIndex = index
    }
  },
  actions: {
    setTabIndex({ commit }, index) {
      commit('SET_TAB_INDEX', index)
    }
  }
}
